import type { JSX } from 'solid-js';
import { Dynamic } from 'solid-js/web';
import { cx } from '../cx';
import type { ClassMap } from './variant';

// The uppercase tracked mono label above a heading. `tone="accent"` is the LINK
// hue, not the working accent — a kicker is never live state.
export type KickerTone = 'muted' | 'accent';
export type KickerElement = 'p' | 'span';

export type KickerProps = {
  readonly tone?: KickerTone;
  readonly as?: KickerElement;
  readonly children: JSX.Element;
};

export const KICKER_TONE_CLASS: ClassMap<KickerTone> = {
  muted: 'ui-kicker--muted',
  accent: 'ui-kicker--accent',
};

export function Kicker(props: KickerProps): JSX.Element {
  return (
    <Dynamic
      component={props.as ?? 'p'}
      class={cx('ui-kicker', KICKER_TONE_CLASS[props.tone ?? 'muted'])}
    >
      {props.children}
    </Dynamic>
  );
}
